import React from "react";
import { Agreements } from "./Management/Agreements";

export const ContractAgentByUser = ({ user, locale }) => {
  const agreementLocale = locale ?? user.locale;
  const { levelValue } = user?.contractAgent?.contractAgentClass;
  const AgreementComponent = Agreements?.[agreementLocale]?.[levelValue] ?? Agreements.DEFAULT;

  return <AgreementComponent user={user} />;
};
